export const DESKTOP_FILTERS_MICROFRONTEND_MANIFEST = 'desktopFiltersMicrofrontendManifest';
export const SEARCH_STRING_MANIFEST_INFO_SETTING_KEY = 'searchStringManifestInfo';
